import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'role', en);

const RoleListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Roles',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.ROLE,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/role/list',
      component: React.lazy(() => import('./RoleList')),
    },
  ],
};

export default RoleListConfig;
